import { useEffect, useMemo, useState } from 'react';

import { type Device, devices, makeMediaQuery } from '../theme/breakpoints';

export const useMatchDevice = (device: Device): boolean => {
  const mediaQuery = makeMediaQuery(devices[device]);
  const matchMedia = useMemo(() => globalThis.matchMedia?.(mediaQuery.replace('@media ', '')), [mediaQuery]);
  const [matches, setMatches] = useState(matchMedia?.matches || false);

  useEffect(() => {
    const listener = () => setMatches(matchMedia.matches);
    if (matchMedia?.addEventListener) {
      matchMedia?.addEventListener('change', listener);
    } else if (matchMedia?.addListener) {
      matchMedia?.addListener(listener);
    }
    return () => {
      if (matchMedia?.removeEventListener) {
        matchMedia?.removeEventListener('change', listener);
      } else if (matchMedia?.removeListener) {
        matchMedia?.removeListener(listener);
      }
    };
  }, [matchMedia]);

  return matches;
};
